import { useState } from 'react';

import { TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import { WorkOrderField } from '@atom/types/work';
import { PREVIEW_FIELD_WIDTH } from '@atom/utilities/taskUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import classes from './workOrderFields.module.css';

interface Props {
  field: WorkOrderField;
  onChange: (fieldId: string, value: any) => void;
  onBlur: (fieldId: string, value: any) => void;
  isDisabled?: boolean;
  width?: string;
  requiredFieldIds?: Set<string>;
  requiredFieldName?: keyof WorkOrderField;
  isTemplate?: boolean;
  onClick?: () => void;
  error?: boolean;
  helperText?: string;
}

const WorkOrderNumericField = ({
  field,
  onChange,
  onBlur,
  isDisabled,
  width = PREVIEW_FIELD_WIDTH,
  requiredFieldIds = new Set([]),
  requiredFieldName = 'requiredOnCreate',
  isTemplate,
  onClick,
  error,
  helperText,
}: Props) => {
  const [value, setValue] = useState<any>(
    !isNilOrEmpty(field?.value) ? field?.value : '',
  );

  const handleChange = event => {
    const number =
      event.target.value === '' ? '' : parseFloat(event.target.value);
    setValue(number);
    onChange(field.id, number);
  };

  const handleOnBlur = event => {
    const number =
      event.target.value === '' ? '' : parseFloat(event.target.value);

    if (field?.value !== number) {
      setValue(number);
      onBlur(field.id, number);
    }
  };

  const fieldUnit = field?.units ? ` (${field?.units})` : '';

  const labelColor = requiredFieldIds.has(field.id)
    ? colors.brand.red
    : colors.neutral.dim;

  // template displays asterisk on required or requiredOnCreate
  const text =
    (isTemplate && (field.required || field.requiredOnCreate)) ||
    !!field[requiredFieldName]
      ? `* ${field.title}`
      : field.title;

  return (
    <div onClick={onClick}>
      <div
        className={classes.fieldTitle}
        style={{ color: labelColor, maxWidth: width }}
      >
        {text + fieldUnit}
      </div>
      <TextField
        id={field.id}
        style={{ width }}
        type="number"
        value={value}
        disabled={isDisabled}
        onChange={handleChange}
        onBlur={handleOnBlur}
        onClick={onClick}
        error={error}
        helperText={helperText}
        data-cy={`workInfoField-${field.title}-NumberInput`}
      />
    </div>
  );
};

export default WorkOrderNumericField;
